import { render, staticRenderFns } from "./AddBankPhone.vue?vue&type=template&id=1eab8b54&scoped=true&"
import script from "./AddBankPhone.vue?vue&type=script&lang=js&"
export * from "./AddBankPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eab8b54",
  null
  
)

export default component.exports